<template>

    <div class="page-wrapper">

       <!-- Menu Superior de Navegación -->
       <navbar-new></navbar-new>

       <iehcontrol-start></iehcontrol-start>

      <caseta></caseta>

      <!-- Iconos Grandes fondo verde -->
       <feature></feature>
      
       <!-- Tabla -->
       <table1></table1>

       <table2></table2>

       <!-- <accordion></accordion> -->

       <!-- Pie de Página -->
       <footer-new></footer-new>
        

    </div>
</template>
  
<script>
  import navbarNew from '../components/navbar.vue'

  import iehcontrolStart from '../components/iehcontrol/iehcontrolStart.vue'

  import caseta from '../components/iehcontrol/caseta.vue'

  import feature from '../components/iehcontrol/feature.vue'

  import table1 from '../components/iehcontrol/table1.vue'

  import table2 from '../components/iehcontrol/table2.vue'

  // import accordion from '../components/iehcontrol/accordion.vue'

  import footerNew from '../components/footer.vue'

  export default {
    components: {
    navbarNew,
    iehcontrolStart,
    caseta,
    feature,
    table1,
    table2,
    // accordion,
    footerNew
  }
  }
  
</script>
  